<div id="couponExp-content-con">
    <audio id="audioPlayer"></audio>
    <div class="ui-dialog-title clearfix">
        <p>通话体验区</p>
        <h6 style="font-size: 13px;text-align: center;padding: 5px;color: #999">可使用通话体验券免费拨打六分钟咨询电话</h6>
    </div>
    <div class="experList-con clearfix">
      {{each OnlyOneData item index}}
        <div class="experItem fl">
            <dl>
                <dt>
                <a href="/home.html?userid={{item.UserID}}&isf=1">
                    <img class="portrait" src="{{item.SmallDataUrl}}">
                </a>
                </dt>
                <dd>
                    <div class="headline clearfix">
                        <h2>{{item.NickName}}</h2>
                        {{if item.Sex=='1'}}
                            <span class="malebg">
                                <i class="iconfont icon-nanxing"></i><label class="">{{item.Age}}</label>
                            </span>
                        {{else if item.Sex=='2'}}
                            <span class="femalebg">
                                <i class="iconfont icon-nvxing"></i><label class="">{{item.Age}}</label>
                            </span>
                        {{/if}}
                        {{if item.IsVip}}
                            <span class="vip">
                                <img src="../../../../public/images/vip.png">
                            </span>
                        {{/if}}
                    </div>
                    <div class='footline'>
                        {{if item.MediaLength > 0}} 
                            <div class="voice-box" data-media={{item.MediaUrl}} data-time={{item.MediaLength}} onclick="playVoice(this)">
                                <div class="rhythm_box">
                                    <span class="line2"></span>
                                    <span class="line3"></span>
                                    <span class="line4"></span>
                                </div>
                                <div class="pause_rhythm">
                                    <span class="line2"></span>
                                    <span class="line3"></span>
                                    <span class="line4"></span>
                                </div>
                                <label class="fr timeL" data-ctime={{item.MediaLength}}>{{item.transMediaLength}}</label>
                            </div>
                        {{else}}
                            <div class="mytip">{{item.MyTips}}</div>
                        {{/if}}
                    </div>
                </dd>
            </dl>
        </div>
        {{/each}}
    </div>
</div>
<div class="btn-wrap" style="text-align: center;padding-bottom: 40px;">
    <button type="button" class="w180btn themeColor" id="changeAnother">换一批</button>
</div>


